import React from 'react';
import styles from './Networking.module.css';

const Networking: React.FC = () => {
  return (
    <section
      className={styles.networking}
    >
      <div className={styles.container}>
        <div className={styles.right}>
          <h2 className={styles.title}>NETWORKING :</h2>
          <p className={styles.text}>
            Rencontrez des décideurs et des pairs de l'industrie pour partager
            des idées et explorer de nouvelles collaborations.
          </p>
        </div>
        <div className={styles.left}>
          <img
            src="/assets/images/networking-illustration.jpg"
            alt="Networking"
            className={styles.image}
          />
        </div>
      </div>
    </section>
  );
};

export default Networking;
